export var getCompatiblePropValue = function getCompatiblePropValue(newValue, oldValue, defaultOldValue) {
  if (oldValue !== undefined) {
    return oldValue;
  }

  if (newValue !== undefined) {
    return newValue;
  }

  return defaultOldValue;
};